import { render } from "./politica-de-privacidade.vue?vue&type=template&id=d0e5a03c"
import script from "./politica-de-privacidade.vue?vue&type=script&lang=js"
export * from "./politica-de-privacidade.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__